import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import AudioPlayer from '@/views/components/recorder/player'
import AudioRecorder from '@/views/components/recorder/recorder'

Vue.component(FeatherIcon.name, FeatherIcon)

Vue.component('audio-player', AudioPlayer)
Vue.component('audio-recorder', AudioRecorder)
